import { TenantFeatureModel } from '@utmost.co/enterprise-models';
import { EngagementStatusSettings } from './EngagementStatus.types';

export const mergeMultiEngagementSettings = (
  settings: EngagementStatusSettings,
  engagementOffboardAutoTransition: TenantFeatureModel
): TenantFeatureModel => ({
  ...engagementOffboardAutoTransition,
  enabled: settings.enabled,
  config: {
    ...engagementOffboardAutoTransition.config,
    status: settings.status,
    'days-shift': settings.daysShift,
    'use-worker-timezone': settings.useWorkerTimezone
  }
});
